export var getHttpCommonHeaders = function (hostingService) {
    var instance = hostingService.getInstance();
    return {
        Authorization: instance,
        'X-ecom-instance': instance,
    };
};
//# sourceMappingURL=http.js.map